import React, { useEffect, useRef, useState } from "react";
import IPERCService from "../../services/IPERCService";
import {
  IRequestTableHistoricoIPERC,
  ITableIPERCPorSupervisor,
} from "../../Interfaces/IIpercBase";
import { InitialRequestTableHistoricoIPERC } from "../../utils/Initials/ListIperc";
import { ISearchBox } from "@fluentui/react";
import { _formatDate } from "../../utils/helpers/dateHelpers";
interface IFilterFechasDate {
  filterFechaInicio: Date | undefined;
  filterFechaFin: Date | undefined;
}
export const useIpercPorSupervisor = () => {
  const controllerRef = useRef<AbortController>(new AbortController());

  const [filterFechas, setFilterFechas] = useState<IFilterFechasDate>({
    filterFechaInicio: new Date(),
    filterFechaFin: new Date(),
  });
  const searchBoxRefTable = useRef<ISearchBox>(null);

  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState<IRequestTableHistoricoIPERC>(
    InitialRequestTableHistoricoIPERC
  );
  const [dataTable, setDataTable] = useState<ITableIPERCPorSupervisor[]>([]);
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        case "actividad":
          setFilter({ ...filter, actividadId: o.key });
          break;
        case "equipo":
          setFilter({ ...filter, equipoId: o.key });
          break;
        default:
          break;
      }
    }
  };
  const _onChangeChoiceGroup = (e, o) => {
    if (e !== undefined) {
      setFilter({ ...filter, estadoId: o.key });
    }
  };
  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        setFilterFechas({ ...filterFechas, filterFechaInicio: date });
        setFilter({ ...filter, fechaInicio: _formatDate(date, ",") });
        break;
      case "fin":
        setFilter({ ...filter, fechaFin: _formatDate(date, ",") });
        setFilterFechas({ ...filterFechas, filterFechaFin: date });

        break;
      default:
        break;
    }
  };
  
  const postTableIpercPorSupervisor = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;

    setIsLoading(true);
    IPERCService.postListarTableIperc(filter, newController).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setDataTable(res.data.items);
      } else {
        setIsLoading(false);
      }
    });
  };

  const actualizarTabla = () => {
    postTableIpercPorSupervisor();
  };
  const limpiarFiltro = () => {
    setFilter(InitialRequestTableHistoricoIPERC);
    setFilterFechas({
      filterFechaFin: undefined,
      filterFechaInicio: undefined,
    });
  };

  useEffect(() => {
    postTableIpercPorSupervisor();
  }, [filter]);

  return {
    dataTable,
    filterFechas,
    filter,
    searchBoxRefTable,
    _onkeyUpSearchTable,
    isLoading,
    onChangeComboBox,
    _onSelectDate,
    _onChangeChoiceGroup,
    actualizarTabla,
    limpiarFiltro,
  };
};
